import { Injectable, inject } from '@angular/core';
import { Observable, catchError, finalize, of, tap } from 'rxjs';
import { SignupAddress, SignupAddressLookup, SignupAddressStore } from './signup-address.store';
import { CustomerIntakeService } from '../intake/customer-intake.service';

@Injectable({ providedIn: 'root' })
export class SignupAddressService {
  private intake = inject(CustomerIntakeService);
  private store = inject(SignupAddressStore);

  /**
   * Sends the sign-up address to `POST /customer-intake/lookup` and stores the county match; a failed
   * request stores null and the `error` status (→ the page's error state; a 429 goes to /too-many-requests).
   */
  lookupAddress(address: SignupAddress): Observable<SignupAddressLookup | null> {
    this.store.lookupStatus.set('loading');

    return this.intake.lookup(address).pipe(
      tap(result => {
        this.store.lookup.set(result);
        this.store.lookupStatus.set('done');
      }),
      catchError(() => {
        this.store.lookup.set(null);
        this.store.lookupStatus.set('error');
        return of(null);
      }),
      finalize(() => {
        if (this.store.isLookingUp()) this.store.lookupStatus.set('idle');
      }),
    );
  }
}

